import React from 'react';
import {
    Box,
    spacing,
    color,
    radius,
    Text,
    GiftOutlined,
} from '@landr/maestro';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';

const BannerWrapper = styled(Box)`
    background-color: ${color('danger.500', 0.08)};
    padding: ${spacing('lg')};
    margin-bottom: ${spacing('lg')};
    border-radius: ${radius('base')};
`;

const IconWrapper = styled.span`
    color: ${color('danger.700')};
    vertical-align: middle;
    padding-right: ${spacing('xxs')};
`;

const SaleBanner = () => {
    const { endDate, hasSale, saleTitle, saleDesc } = useUpsellActionsContext();

    if (!hasSale || !endDate) {
        return null;
    }

    return (
        <BannerWrapper>
            <IconWrapper>
                <GiftOutlined />
            </IconWrapper>
            <Text fontWeight="bold">
                <RichText render={saleTitle as any} />
                <RichText render={saleDesc as any} />
            </Text>
        </BannerWrapper>
    );
};

export default SaleBanner;
